import React from "react";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import { IS_DESKTOP } from "../util";

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    marginTop: (props) =>
      props.isDesktop ? `-${spacing(11)}px` : `-${spacing(6)}px`,
    paddingBottom: spacing(2),
  },
}));

function Portals({ children, ...props }) {
  const { root } = useStyles({ isDesktop: IS_DESKTOP() });

  return (
    <Container className={root} component={"section"}>
      <Grid
        container
        direction={"row"}
        justify={"center"}
        alignItems={"center"}
        spacing={2}
        {...props}
      >
        {children.map((child, i) => (
          <Grid item key={`PORTALS_CHILD_${i}`} md={6} xs={12}>
            {child}
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Portals;
